import { Box, Flex, Text, Tooltip } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useTranslations } from 'next-intl'

import { useCoinContext } from '@/app/[locale]/price/[slug]/_contexts/CoinContext'
import Share from '@/assets/icons/share.svg'
import Star from '@/assets/icons/star.svg'
import CoinIcon from '@/components/CoinIcon'
import { CoinPrices } from '@/types/coin'
import { gotoCdcWebSignupPage } from '@/utils'

import styles from './index.module.css'
import ShareModal from './ShareModal'
import { SHARE_DOWNLOAD_HELPER_PORTAL_EL_ID } from './ShareModal/utils'

interface CoinTitleProps {
  currentCoinPrices?: CoinPrices
  curTimeRange: string
  slug: string
  customHeader?: React.ReactNode
}

export default function CoinTitle({
  currentCoinPrices,
  curTimeRange,
  slug,
  customHeader,
}: CoinTitleProps) {
  const { coin } = useCoinContext()
  const [shareModalOpened, { open: openShareModal, close: closeShareModal }] = useDisclosure()
  const t = useTranslations()
  return (
    <Flex align={'center'} mb={'sm'}>
      <CoinIcon coin={coin} size={32} />
      {customHeader ? (
        customHeader
      ) : (
        <>
          <Text variant={'heading2'} component="h1" mx={8}>
            {coin.name}
          </Text>
          <Text variant={'heading2'} c={'var(--content-tertiary)'} flex={1}>
            {coin.symbol}
          </Text>
        </>
      )}
      <Flex align="center" gap={16} ml="auto">
        <Tooltip multiline withArrow label={t('chart.share')}>
          <Share className={styles.iconButton} onClick={openShareModal} />
        </Tooltip>
        <Tooltip multiline withArrow label={t('common.addToFavorites')}>
          <Star className={styles.iconButton} onClick={gotoCdcWebSignupPage} />
        </Tooltip>
      </Flex>
      {shareModalOpened && (
        <ShareModal
          slug={slug}
          opened={shareModalOpened}
          onClose={closeShareModal}
          curTimeRange={curTimeRange}
          currentCoinPrices={currentCoinPrices}
        />
      )}
      <Box id={SHARE_DOWNLOAD_HELPER_PORTAL_EL_ID} pos={'fixed'} w={0} h={0} />
    </Flex>
  )
}
